export default {
    name: 'Όνομα',
    tel: 'Τηλέφωνο',
    save: 'Αποθήκευση',
    confirm: 'Επιβεβαίωση',
    cancel: 'Ακύρωση',
    delete: 'Διαγραφή',
    complete: 'Ολοκλήρωση',
    loading: 'Φόρτωση...',
    telEmpty: 'Συμπληρώστε το τηλέφωνο',
    nameEmpty: 'Συμπληρώστε το όνομα',
    nameInvalid: 'Μη έγκυρη μορφή ονόματος',
    confirmDelete: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε;',
    telInvalid: 'Μη έγκυρος αριθμός τηλεφώνου',
    vanCalendar: {
        end: 'Τέλος',
        start: 'Έναρξη',
        title: 'Ημερολόγιο',
        startEnd: 'Έναρξη/Τέλος',
        weekdays: ['Κυρ', 'Δευ', 'Τρί', 'Τετ', 'Πέμ', 'Παρ', 'Σάβ'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Επιλέξτε μέχρι ${maxRange} ημέρες`,
    },
    vanCascader: {
        select: 'Επιλογή',
    },
    vanContactCard: {
        addText: 'Προσθήκη στοιχείων επικοινωνίας',
    },
    vanContactList: {
        addText: 'Προσθήκη νέας επαφής',
    },
    vanPagination: {
        prev: 'Προηγούμενο',
        next: 'Επόμενο',
    },
    vanPullRefresh: {
        pulling: 'Τραβήξτε για ανανέωση...',
        loosing: 'Αφήστε για ανανέωση...',
    },
    vanSubmitBar: {
        label: 'Σύνολο：',
    },
    vanCoupon: {
        unlimited: 'Απεριόριστο',
        discount: (discount) => `${discount * 10}% έκπτωση`,
        condition: (condition) => `Τουλάχιστον ${condition}`,
    },
    vanCouponCell: {
        title: 'Κουπόνι',
        tips: 'Δεν υπάρχουν κουπόνια',
        count: (count) => `Έχετε ${count} κουπόνια`,
    },
    vanCouponList: {
        empty: 'Δεν υπάρχουν κουπόνια',
        exchange: 'Ανταλλαγή',
        close: 'Κλείσιμο',
        enable: 'Διαθέσιμο',
        disabled: 'Μη διαθέσιμο',
        placeholder: 'Κωδικός κουπονιού',
    },
    vanAddressEdit: {
        area: 'Περιοχή',
        postal: 'Ταχυδρομικός κώδικας',
        areaEmpty: 'Επιλέξτε περιοχή παράδοσης',
        addressEmpty: 'Η διεύθυνση δεν μπορεί να είναι κενή',
        postalEmpty: 'Λάθος ταχυδρομικός κώδικας',
        defaultAddress: 'Ορισμός ως προεπιλεγμένη διεύθυνση',
        telPlaceholder: 'Τηλέφωνο',
        namePlaceholder: 'Όνομα',
        areaPlaceholder: 'Περιοχή',
    },
    vanAddressEditDetail: {
        label: 'Διεύθυνση',
        placeholder: 'Διεύθυνση',
    },
    vanAddressList: {
        add: 'Προσθήκη νέας διεύθυνσης',
    },
};